<script setup>
import { ref, computed, onMounted } from 'vue'
import { useGlobalStore } from '@stores/global'
import { Rive, Fit, Layout, Alignment } from '@rive-app/canvas'
import _ from 'lodash'

const eye = ref(null)
const global = useGlobalStore()

const totalClients = computed(() => global.clients.length)
const shuffledClients = computed(() => _.shuffle(global.clients))
const clients1 = computed(() => shuffledClients.value.slice(0, totalClients.value / 3))
const clients2 = computed(() => shuffledClients.value.slice(totalClients.value / 3, (totalClients.value / 3) * 2))
const clients3 = computed(() => shuffledClients.value.slice((totalClients.value / 3) * 2, totalClients.value))

onMounted(() => {
	let rive = new Rive({
		canvas: eye.value,
		src: `https://cdn.papercrowns.com/website/rive/eye.riv`,
		autoplay: true,
		layout: new Layout({
			fit: Fit.Contain,
			// alignment: Alignment.TopCenter,
		}),

		stateMachines: 'crownsStateMachine',
	})
})
</script>

<template>
	<section class="relative overflow-hidden bg-crowns-off-black pb-0 md:pb-10 xl:pb-24">
		<!-- Header -->
		<div class="container">
			<div class="mb-10 flex flex-col items-center gap-5">
				<canvas class="-mb-16 -mt-6 h-56 sm:-mb-20 sm:h-56 lg:h-[300px] xl:-mt-5" width="512" height="512" ref="eye" />
				<!-- <img class="h-20 object-contain" src="https://cdn.papercrowns.com/website/images/elements/etches/eye-crown.png" alt="Eyeball Etch" /> -->

				<div class="flex flex-col items-center gap-3 lg:gap-5">
					<h4>You're not alone</h4>
					<p>Brands &amp; partners that have chosen to build inside our walls.</p>
				</div>
			</div>
		</div>

		<!-- Clients -->
		<div class="relative flex flex-col gap-3 overflow-hidden py-10 md:gap-8" v-if="global.clients.length > 0">
			<div class="flex w-fit items-center odd:animate-marquee-left-slow even:animate-marquee-right-slow" v-for="x in 3">
				<div class="flex flex-shrink-0 items-center gap-3 md:gap-5" v-for="i in 2">
					<img class="h-12 max-w-48 flex-shrink-0 object-contain p-3 px-3 md:h-14 md:px-5 xl:h-16" v-for="(client, i) in x == 1 ? clients1 : x == 2 ? clients2 : clients3" :key="`logo-${x}-${i}`" :src="client.logo_light" :alt="client.name" />
				</div>
			</div>

			<!-- Gradients -->
			<div class="absolute right-0 top-0 h-full w-44 bg-gradient-to-l from-crowns-off-black to-transparent"></div>
			<div class="absolute left-0 top-0 h-full w-44 bg-gradient-to-r from-crowns-off-black to-transparent"></div>
		</div>
	</section>
</template>
